const Footer = () => {

    return (
        <footer className="container text-center">
            Copyright © 2022 Ron Mikhael Surara. All Rights Reserved
        </footer>
    )
}

export default Footer